<template>
    <div :class="rowClass">
        <div class="absolute w-5px pin-t pin-b left-0bg-blue" v-if="selected"></div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            rowClass: {
                type: String
            },
            selected: {
                type: Boolean,
                default: false
            }
        }
    }
</script>
